export default {
    points: [
        { x: 3, y: 653990 },
        { x: 4, y: 649610 },
        { x: 5, y: 660120 },
        { x: 6, y: 669450 },
        { x: 7, y: 727680 },
        { x: 8, y: 716910 },
    ],
    yTicks: [0, 100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000]
}